<div class="alert alert-danger" *ngIf="timeOutError">
  {{timeoutErrorMessage}}
</div>
<div class="col-md-8 offset-2">
<div class="common-padding">
  <div class="col-md-12 col-xs-12 col-sm-12 mt-2 mb-4 heading">
    <span class="span-create-edit-hoshin color">HOSHIN APPROVAL</span>
    <span class="pt-1" *ngIf="(this.adminId==1 || this.adminId=='1')" style="font-size: 13px;"><a href="assets/userguides/HoshinUserguideForSuperAdmins.pdf" download class="pl-3 download-link">User Guide</a></span>
    <span class="pt-1" *ngIf="!(this.adminId==1 || this.adminId=='1')" style="font-size: 13px;"><a href="assets/userguides/HoshinChapterAdminUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
  </div>

  <div class="main-section">

    <div id='included_page' class="form-outer-div">
      <div class="form-group-div">
        <span>
          <ng-select placeholder="--Select SITE--" class="custom" [items]="siteList" bindLabel="siteName"
            bindValue="siteId" [(ngModel)]="siteId" (change)="siteChange($event)"></ng-select>
        </span>
      </div>

      <div class="form-group-div">

        <div>
          <ng-select placeholder="--Select BPG--" class="custom" [items]="bpgList" bindLabel="bpgName"
            [(ngModel)]="bpgId" bindValue="bpgId" (change)="bpgChange($event)"></ng-select>
        </div>
      </div>

      <div class="form-group-div">
        <div>
          <ng-select placeholder="--Select Status--" class="custom" [items]="statusList" bindLabel="status"
          bindValue="status" [(ngModel)]="status" (change)="changeStatus($event)"></ng-select>
        </div>
      </div>

      <div id="searchSecn">
        <button type="button" class="btn btn-danger" (click)="searchChapter()">Search</button>
      </div>
    </div>


  </div>
</div>

<p class="noDataFound" *ngIf="noDataFound"> No data found </p>
<div class="table-data" *ngIf="tableShow">
  <div class="table-container">
    <table aria-describedby="table" [ngClass]="{'table-responsive':tableresp}" class="table table-striped " id="tabledemo">
      <thead>
        <tr class="tr-th">
          <th scope="col" style="width: 25%;">Site</th>
          <th scope="col" style="width: 60%;">BPG</th>
          <th scope="col" style="width: 30%;">Hoshin Status</th>
          <th scope="col" style="width: 10%;">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let data of chaptersData  | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }">
          <td>{{data.siteName}}</td>
          <td>{{data.bpgName}}</td>
          <td>{{data.budgetStatus}}</td>
          <td>
            <a style="color: #b62027;" (click)="viewMoreHoshinDetails(data)"><b>View</b></a>
          </td>
        </tr>

      </tbody>
    </table>
    <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>

  </div>

  <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
    <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
    <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
  </div>
</div>
</div>